import ResizeController from '../../assets/js/controllers/resize';

import Platform from '../../assets/js/constants/platform';

import { getRootOffsetBounds, multiAddEventListener, multiRemoveEventListener, querySelectorArray } from '../../assets/js/helpers';

export default class TabUnderline {

	static selector = '[data-tab-underline]';

	// class variables

	attributes = {};

	config = {};

	controllers = {
		resize: null
	};

	coords = {
		mask: {
			width: 0
		}
	};

	el = {};

	flags = {};

	selectors = {
		// elements
		mask: '[data-tab-underline-mask]', // (optional) will default to container
		handle: '[data-tab-underline-handle]',
		items: '[data-tab-underline-item]'
	};

	states = {
		activeItem: null
	};

	// constructor

	constructor(container) {
		this.el = {
			container,

			// singles
			mask: container.querySelector(this.selectors.mask) || container,
			handle: container.querySelector(this.selectors.handle),

			// multiples
			items: container.querySelectorAll(this.selectors.items)
		};

		this.initialize();
	}

	// init

	initialize() {
		this.#addEventListeners();
		this.measureResize();
		this.adjustResize();
	}

	// event listeners

	#addEventListeners = () => {
		multiAddEventListener(this.el.items, 'mouseenter', this.#onItemOver);
		this.el.container.addEventListener('mouseleave', this.#onContainerLeave);
		this.controllers.resize = ResizeController.set({
			update: this.#onResizeUpdate,
			render: this.#onResizeRender
		});
	}

	#removeEventListeners = () => {
		multiRemoveEventListener(this.el.items, 'mouseenter', this.#onItemOver);
		this.el.container.removeEventListener('mouseleave', this.#onContainerLeave);
		ResizeController.clear(this.controllers.resize);
	}

	// listener methods

	#onItemClick = (e) => {
		const $target = e.currentTarget;
		this.changeActiveItem($target);
	};

	#onItemOver = (e) => {
		const $target = e.currentTarget;
		this.changeActiveItem($target, false);
	};

	#onContainerLeave = (e) => {
		const $target = e.currentTarget;
		this.changeActiveItem(this.states.activeItem);
	};

	// controller methods

	#onResizeUpdate = () => this.measureResize();
	#onResizeRender = () => {
		this.adjustResize();
	}

	//

	measureResize() {
		this.coords.mask.width = this.el.mask.offsetWidth;
		return true;
	}

	adjustResize() {
		this.el.handle.style.transformOrigin = '0% 50%';
		this.checkActiveItem();
	}

	//

	changeActiveItem($item, isSetting = true) {
		if ($item) {
			const nextItemBounds = getRootOffsetBounds($item, this.el.container);

			if (isSetting || $item === this.states.activeItem) {
				this.states.activeItem = $item;
				this.el.handle.style.background = '#FF3333';
			} else {
				this.el.handle.style.background = '#2A2A2D';
			}

			const handleX = nextItemBounds.left;
			const handleScaleX = nextItemBounds.width / this.coords.mask.width;
			this.el.handle.style.transform = `translateX(${handleX}px) scaleX(${handleScaleX})`;
		}
	}

	checkActiveItem() {
		const $activeItem = querySelectorArray(this.el.items, '.is-active', true);
		this.changeActiveItem($activeItem);
	}

	//

	enable() {
		this.flags.isEnabled = true;
	}

	disable() {
		this.flags.isEnabled = false;
	}

	// destroy

	destroy() {
		this.#removeEventListeners();
	}

}
